(function () {
  if (window.__collectionSwatchBound) return;
  window.__collectionSwatchBound = true;

  /* --------------------
     HELPERS
  -------------------- */
  function closestProduct(el) {
    return (el && el.closest) ? el.closest('.grid__item.grid-product') : null;
  }

  function findMainImageEl(productEl) {
    if (!productEl) return null;
    return productEl.querySelector(
      'img.grid-product__image, .grid__image-ratio img, .image-wrap img'
    );
  }

  function setMainImage(productEl, src) {
    if (!productEl || !src) return;
    var img = findMainImageEl(productEl);
    if (!img) return;

    img.src = src;
    img.srcset = src;
    img.setAttribute('data-src', src);
    img.setAttribute('data-original', src);
  }

  function getHiddenPrice(productEl, variantId) {
    if (!productEl || !variantId) return null;
    return productEl.querySelector(
      '.variant-prices .variant-price[data-variant-id="' + variantId + '"]'
    );
  }

  function clearOtherActives(productEl, exceptEl) {
    if (!productEl) return;
    productEl
      .querySelectorAll('[class*="grid-product__color-image"].is-active')
      .forEach(function(el){
        if (el !== exceptEl) el.classList.remove('is-active');
      });
  }

  function normalizeColor(val) {
    return (val || '').toLowerCase().trim();
  }

  function setSwatchHidden(el, hidden) {
    if (!el) return;

    if (hidden) {
      if (!el.classList.contains('is-filter-hidden')) {
        el.classList.add('is-filter-hidden');
      }
    } else {
      if (el.classList.contains('is-filter-hidden')) {
        el.classList.remove('is-filter-hidden');
      }
    }
  }

  function getGridItem(productEl) {
    return productEl && productEl.classList.contains('grid__item')
      ? productEl
      : productEl.closest('.grid__item');
  }

  function removeGridItem(gridItem) {
    if (!gridItem || gridItem.__removed) return;

    const parent = gridItem.parentNode;
    if (!parent) return;

    const placeholder = document.createComment('product-hidden');
    parent.insertBefore(placeholder, gridItem);

    gridItem.__placeholder = placeholder;
    gridItem.__parent = parent;

    parent.removeChild(gridItem);
    gridItem.__removed = true;
  }

  function restoreGridItem(gridItem) {
    if (!gridItem || !gridItem.__removed) return;

    const placeholder = gridItem.__placeholder;
    const parent = gridItem.__parent;

    if (placeholder && parent) {
      parent.insertBefore(gridItem, placeholder);
      parent.removeChild(placeholder);
    }

    delete gridItem.__placeholder;
    delete gridItem.__parent;
    gridItem.__removed = false;
  }

  function updateSaleBadge(productEl, variantId) {
    if (!productEl || !variantId) return;

    const badges = productEl.querySelectorAll(
      '.grid-product__tag--sale-variant'
    );

    badges.forEach(badge => {
      badge.style.display =
        badge.dataset.variantId === variantId ? '' : 'none';
    });
  }

  /* --------------------
     MAIN HOVER LOGIC
  -------------------- */

  function applySwatch(productEl, swatch) {
    var variantId = swatch.dataset.variantId;
    var variantImage = swatch.dataset.variantImage;
    if (!variantId || !variantImage) return;

    var colorEl = productEl.querySelector(
      '.grid-product__color-image--' + variantId
    );

    clearOtherActives(productEl, colorEl);

    if (colorEl) {
      colorEl.style.backgroundImage = 'url(' + variantImage + ')';
      colorEl.classList.add('is-active');
    }

    setMainImage(productEl, variantImage);

    var hidden = getHiddenPrice(productEl, variantId);
    if (hidden) {
      var priceWrap = productEl.querySelector('.grid-product__price');
      if (priceWrap) priceWrap.innerHTML = hidden.innerHTML;
    }

    productEl.dataset.stickyVariantId = variantId;
    productEl.dataset.stickyVariantImage = variantImage;

    updateSaleBadge(productEl, variantId);
  }

  function restoreSticky(productEl) {
    var vid = productEl.dataset.stickyVariantId;
    var vimg = productEl.dataset.stickyVariantImage;
    if (!vid || !vimg) return;

    var active = productEl.querySelector(
      '.grid-product__color-image--' + vid + '.is-active'
    );
    if (active) return;

    var colorEl = productEl.querySelector(
      '.grid-product__color-image--' + vid
    );
    if (colorEl) {
      colorEl.style.backgroundImage = 'url(' + vimg + ')';
      colorEl.classList.add('is-active');
    }

    setMainImage(productEl, vimg);
  }

  function hoveredProduct(e) {
    var targetEl = e.target;
    if (!targetEl || targetEl.nodeType !== 1) return null;
    return targetEl.closest('.grid__item.grid-product');
  }

  function hoveredSwatch(e, productEl) {
    var swatch = e.target.closest('.color-swatch');
    return swatch && productEl.contains(swatch) ? swatch : null;
  }

  function handleHover(e) {
    var productEl = hoveredProduct(e);
    if (!productEl) return;

    var swatch = hoveredSwatch(e, productEl);
    if (swatch) applySwatch(productEl, swatch);

    restoreSticky(productEl);
  }

  function handleTouch(e) {
    var productEl = hoveredProduct(e);
    if (!productEl) return;

    var swatch = hoveredSwatch(e, productEl);
    if (swatch) applySwatch(productEl, swatch);
  }

  document.addEventListener('mouseover', handleHover, true);
  document.addEventListener('touchstart', handleTouch, { passive: true });

  /* --------------------
     UTILITY
  -------------------- */
  window.clearCollectionSwatchSticky = function () {
    document
      .querySelectorAll('.grid__item.grid-product')
      .forEach(function (p) {
        delete p.dataset.stickyVariantId;
        delete p.dataset.stickyVariantImage;
        p
          .querySelectorAll('[class*="grid-product__color-image"].is-active')
          .forEach(function(el){ el.classList.remove('is-active'); });
      });
  };

  /* =====================================================
    FILTER COLOR INTEGRATION (ADD-ON ONLY)
  ===================================================== */
  function getVisibleProducts() {
    const grid = document.querySelector('#MainContent .grid');
    if (!grid) return [];

    const seen = new Set();
    const products = [];

    grid.querySelectorAll('.grid__item.grid-product').forEach(el => {
      const id = el.getAttribute('data-product-id');
      if (!id) return;

      if (seen.has(id)) return;

      seen.add(id);
      products.push(el);
    });

    return products;
  }

  function updateVisibleProductCount() {
    const products = getVisibleProducts();
    const countEl = document.querySelector('.collection-filter__item--count');
    if (!countEl) return;

    countEl.textContent =
      products.length + ' product' + (products.length !== 1 ? 's' : '');
  }

  function getActiveFilterColors() {
    var params = new URLSearchParams(window.location.search);
    var gids = params.getAll('filter.v.t.shopify.color-pattern');
    var ids = [];
    var names = [];

    gids.forEach(function (gid) {
      var id = String(gid).split('/').pop();
      if (id) ids.push(id);

      var input = document.querySelector(
        'input[name="filter.v.t.shopify.color-pattern"][value="' +
          CSS.escape(gid) +
          '"]'
      );
      var label = input ? input.closest('label') : null;
      var swatch = label ? label.querySelector('.color-swatch') : null;

      if (swatch) names.push(normalizeColor(swatch.getAttribute('title')));
    });

    return { ids: ids, names: names };
  }

  function productColorIds(productEl) {
    return (productEl.dataset.productColorIds || '').split(/\s+/).filter(Boolean);
  }

  function cardAllowedByIds(productEl, activeColors, useCardIds) {
    if (!useCardIds) return null;

    var ids = productColorIds(productEl);
    if (!ids.length) return null;

    return ids.some(function (id) { return activeColors.ids.indexOf(id) !== -1; });
  }

  function swatchMatches(swatch, activeColors) {
    var gid = swatch.dataset.colorId;
    if (gid && activeColors.ids.indexOf(gid) !== -1) return true;

    return activeColors.names.indexOf(normalizeColor(swatch.dataset.color)) !== -1;
  }

  function filterResolves(activeColors) {
    return Array.prototype.some.call(
      document.querySelectorAll('.color-swatch[data-color]'),
      function (swatch) {
        if (swatch.dataset.variantHidden === 'true') return false;
        return swatchMatches(swatch, activeColors);
      }
    );
  }

  function applyFilterToProducts() {
    var activeColors = getActiveFilterColors();

    var hasIds = activeColors.ids.length > 0;
    var gridHasCardIds = !!document.querySelector('.grid-product[data-product-color-ids]:not([data-product-color-ids=""])');
    var useCardIds = hasIds && gridHasCardIds;
    var hasFilter = useCardIds || activeColors.names.length > 0;
    var narrow = hasFilter && filterResolves(activeColors);
    var MAX_SWATCHES = 6;

    document.querySelectorAll('.grid__item.grid-product').forEach(function (productEl) {
      var swatches = Array.from(
        productEl.querySelectorAll('.color-swatch[data-color]')
      );

      if (!swatches.length) return;

      var visibleCount = 0;
      var matchedCount = 0;
      var firstMatched = null;

      swatches.forEach(function (swatch) {
        if (swatch.dataset.initiallyHidden === undefined) {
          swatch.dataset.initiallyHidden =
            swatch.classList.contains('is-initially-hidden') ? 'true' : 'false';
        }
        var wasInitiallyHidden = swatch.dataset.initiallyHidden === 'true';

        var match = narrow && swatchMatches(swatch, activeColors);
        var isHidden = swatch.dataset.variantHidden === 'true';

        if (!narrow) {
          if (wasInitiallyHidden) {
            swatch.classList.add('is-initially-hidden');
          } else {
            swatch.classList.remove('is-initially-hidden');
          }
          setSwatchHidden(swatch, wasInitiallyHidden);
          return;
        }

        if (match && !isHidden) {
          matchedCount++;
        }

        if (match && !isHidden && visibleCount < MAX_SWATCHES) {
          setSwatchHidden(swatch, false);
          swatch.classList.remove('is-initially-hidden');
          visibleCount++;

          if (!firstMatched) firstMatched = swatch;
        } else {
          setSwatchHidden(swatch, true);
        }
      });

      const gridItem = productEl;

      if (!narrow) {
        if (cardAllowedByIds(productEl, activeColors, useCardIds) === false) {
          removeGridItem(gridItem);
          return;
        }
        restoreGridItem(gridItem);
      } else if (visibleCount === 0) {
        removeGridItem(gridItem);
        return;
      } else {
        restoreGridItem(gridItem);
      }

      var more = productEl.querySelector('.color-swatch--more');
      if (more) {
        more.style.display =
          !narrow || matchedCount > MAX_SWATCHES ? '' : 'none';
      }

      if (firstMatched && !productEl.dataset.stickyVariantId) {
        var vid = firstMatched.dataset.variantId;
        var vimg = firstMatched.dataset.variantImage;

        if (vid && vimg) {
          setMainImage(productEl, vimg);
          updateSaleBadge(productEl, vid);

          var hidden = getHiddenPrice(productEl, vid);
          if (hidden) {
            var priceWrap = productEl.querySelector('.grid-product__price');
            if (priceWrap) priceWrap.innerHTML = hidden.innerHTML;
          }

          productEl.dataset.stickyVariantId = vid;
          productEl.dataset.stickyVariantImage = vimg;
        }
      }

      var link = productEl.querySelector('a.grid-product__link');
      if (link && vid) {
        var url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', vid);
        link.href = url.pathname + '?' + url.searchParams.toString();
      }

      var colorsWrap = productEl.querySelector('.grid-product__colors');
      if (!colorsWrap) return;

      colorsWrap.style.visibility = 'hidden';
      colorsWrap.style.visibility = 'visible';
    });

    updateVisibleProductCount();
  }

  document.querySelectorAll('.grid__item.grid-product').forEach(p => {
    const vid = p.dataset.stickyVariantId;
    if (vid) updateSaleBadge(p, vid);
  });

  /* ======================
    SHOPIFY AJAX FILTER HOOK
  ====================== */

  (function bindMainContentObserver() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    var scheduled = false;

    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          scheduled = false;

          if (!document.querySelector('.grid__item.grid-product')) return;
          applyFilterToProducts();
        });
      });
    });

    observer.observe(main, {
      childList: true,
      subtree: true
    });
  })();

  applyFilterToProducts();
})();
